import {
  IServiceTypePrice,
  IServiceTypePriceData,
  IServiceTypePriceReverse,
  IServiceTypePriceReverseData
} from './index'
import {
  Category
} from '../abstract'
import {
  IServiceTypeSimple,
  ServiceTypeSimple
} from '../index'


export class ServiceTypePrice implements IServiceTypePrice {
  readonly id?: number
  readonly price: number
  readonly category?: Category
  readonly is_quiz_required: boolean
  readonly is_unlimited: boolean

  constructor(data?: IServiceTypePriceData) {
    this.id = data?.id
    let price = data?.price;
    price = (typeof price === 'string') ? parseFloat(price) : price
    this.price = price || 0
    this.category = data?.category
    this.is_quiz_required = !!data?.is_quiz_required
    this.is_unlimited = !!data?.is_unlimited
  }

  validate(): boolean {
    return this.validatePrice()
  }

  validatePrice(): boolean {
    let price = this.price
    return !!price && price > 0
  }

  update(data?: IServiceTypePriceData) {
    // update fields
  }
}

export class ServiceTypePriceReverse extends ServiceTypePrice implements IServiceTypePriceReverse {
  service_type: IServiceTypeSimple

  constructor(data: IServiceTypePriceReverseData) {
    super(data);
    this.service_type = new ServiceTypeSimple(data.service_type)
  }

  validate(): boolean {
    return super.validate() && this.service_type.validate()
  }

  update(data?: IServiceTypePriceReverseData) {
    super.update(data)
    let type = data?.service_type
    if (type) {
      this.service_type.update(type)
    }
  }
}
